<template>
  <div style="min-height: calc(100vh - 120px);">
    <div class="uk-overlay-primary uk-position-cover"></div>
    <div class="uk-position-center uk-padding">
      <div class="uk-width-large uk-card uk-card-default uk-border-rounded login-form">
        <div class="uk-padding uk-padding-remove-bottom">
          <div data-uk-grid class="uk-grid">
            <div class="uk-width-1-1 uk-flex-center">
              <div class="uk-text-center uk-margin">
                <div class="login-logo" v-if="tenant">
                  <img :src="tenant.logo" alt="Logo" />
                </div>
                <div v-if="tenant.knumber === 'K10122'" class="uk-text-danger">
                    <p>
                      Im Laufe des Tages erreichen Sie uns unter <a href="https://jungwagen.fleetpool.de" target="_blank" class="uk-link-reset uk-text-bold">https://jungwagen.fleetpool.de</a>.<br><br> 
                      Dort müssen Sie sich dann aufgrund unserer geänderten AGB`s neu registrieren.
                    </p>
                    <p>
                      Vielen Dank für Ihr Verständnis!
                    </p>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex-center">
                <div class="uk-width-large uk-margin-auto">
                  <div class="uk-alert uk-alert-danger" v-if="error">
                    Die eingegebenen Daten sind ungültig.
                  </div>
                  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                  <form role="form" @submit.prevent="handleSubmit(submit)" class="toggle-class">
                    <fieldset class="uk-fieldset">
                      <div class="uk-margin">
                        <div class="uk-inline uk-width-1-1">
                          <span data-uk-icon="icon: mail" class="uk-form-icon uk-form-icon-flip uk-icon"> </span>
                          <ValidationProvider :rules="'required'" name="email" v-slot="{ errors }">
                          <input
                            placeholder="E-Mail" 
                            @paste="onPaste('email', $event)"
                            type="text"
                            class="uk-input"
                            v-model="email"
                            :class="{ 'uk-form-danger': errors[0] }"
                          />
                        </ValidationProvider>
                        </div>
                      </div>
                      <div class="uk-margin">
                        <div class="uk-inline uk-width-1-1">
                          <span data-uk-icon="icon: lock" class="uk-form-icon uk-form-icon-flip uk-icon"></span>
                          <ValidationProvider :rules="'required'" name="password" v-slot="{ errors }">
                            <input
                            @paste="onPaste('password', $event)"
                            placeholder="Passwort"
                              class="uk-input"
                              type="password"
                              name="password"
                              v-model="password"
                              :class="{ 'uk-form-danger': errors[0] }"
                            />
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="uk-margin-top">
                        <div class="uk-flex uk-flex-center">
                          <button class="uk-button uk-button-primary uk-border-rounded uk-text-uppercase">
                            anmelden
                          </button>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                </ValidationObserver>
                  <form class="toggle-class" hidden @submit.prevent="passwordReset">
                    <div class="uk-margin-small">
                      <div class="uk-inline uk-width-1-1">
                        <span class="uk-form-icon uk-form-icon-flip uk-icon" data-uk-icon="icon: mail"></span>
                        <input v-model="email" class="uk-input" placeholder="E-Mail" required type="text" />
                      </div>
                    </div>
                    <div class="uk-margin-bottom">
                      <div class="uk-flex uk-flex-center">
                        <button type="submit" class="uk-button uk-button-primary uk-border-rounded" :disabled="loading">
                          <div data-uk-spinner="ratio: 0.6" v-if="loading"></div>
                          Passwort zurücksetzen
                        </button>
                      </div>
                    </div>
                  </form>
                  <div>
                    <div class="uk-text-center">
                      <a
                        class="uk-link-reset uk-text-small toggle-class"
                        data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade"
                        aria-hidden="false"
                        >Passwort vergessen?</a
                      >
                      <a
                        class="uk-link-reset uk-text-small toggle-class"
                        data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade"
                        aria-hidden="true"
                        hidden
                      >
                        <span data-uk-icon="arrow-left" class="uk-icon"></span>
                        Zurück zum Login
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-flex-center uk-margin-small">
              <div class="uk-width-large">
                <div class="uk-alert uk-alert-danger" v-if="passwordResetError">
                  E-Mail Adresse nicht bekannt!
                </div>
                <div class="uk-alert uk-alert-success" v-if="passwordResetSent">E-Mail gesendet!</div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="uk-tile uk-tile-muted uk-padding-small uk-text-small uk-text-center"
          style="border-bottom-right-radius: 5px;border-bottom-left-radius: 5px;"
          v-if="showRegister"
        >
          <p class="uk-text-bold">
            Beantragen Sie jetzt Ihren persönlichen Händlerzugang
          </p>
          <p>
            Nach Ihrer Registrierung und der Erstellung Ihres Kundenkontos können Sie sich jederzeit im Händlerportal
            einloggen.
          </p>
          <div class="uk-flex uk-flex-center">
            <button
              class="uk-button uk-button-primary uk-button-small uk-text-uppercase"
              data-uk-toggle="#register-modal"
            >
              Händlerzugang anfordern
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="register-modal" ref="registerModal" class="uk-modal-container" data-uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
          <h2 class="uk-modal-title">Registrierung</h2>
        </div>
        <div class="uk-modal-body" uk-overflow-auto>
          <register @completed="onRegisterComplete"></register>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { mapActions, mapGetters } from 'vuex'
import UserService from '@/services/user.service.js'
import Register from '@/components/Register.vue'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})


export default {

  data() {
    return {
      passwordResetSent: false,
      passwordResetError: false,
      loading: false,
      email: null,
      password: null,
      sending: false,
      errors: [],
      error: false
    }
  },
  components: { Register, ValidationProvider, ValidationObserver },
  mounted() {
    //this.$store.commit('SET_LAYOUT', 'login-layout')
  },
  computed: {
    ...mapGetters({ user: 'auth/user', tenant: 'tenant' }),
    showRegister() {
      return this.tenant.knumber === 'K10140' || 
        this.tenant.knumber === 'K10149' || 
        this.tenant.knumber === 'K10159' || 
        this.tenant.knumber === 'K10167' || 
        this.tenant.knumber === 'K10166'
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),

    async submit() {
      this.sending = true
      let form = new FormData()
      form.append('email', this.email)
      form.append('password', this.password)
      try {
        await this.login({
          payload: form,
          context: this
        });

        if (this.$route.query.redirect) {
          this.$router.replace(this.$route.query.redirect)
          return
        }

        this.$router.replace({ name: 'Index' })
      } catch (error) {
        this.sending = false
      }
    },
    async passwordReset() {
      this.loading = true

      try {
        await UserService.passwordReset({ email: this.email })

        this.passwordResetSent = true
        this.loading = false
        this.email = ''
        setTimeout(() => {
          this.passwordResetSent = false
        }, 4000)
      } catch (error) {
        this.loading = false
        this.email = ''
        this.passwordResetError = true
        setTimeout(() => {
          this.passwordResetError = false
        }, 4000)
      }
    },
    onRegisterComplete() {
      setTimeout(() => {
        this.$uikit.modal(this.$refs.registerModal).hide()
        setTimeout(() => {
          this.$router.go(this.$router.currentRoute)
        }, 500)
      }, 2000)
    },
    onPaste(field, event) {
      let str = event.clipboardData.getData('text/plain')
      str = str.replace(/\s{2,}/g, ' ')
      str = str.replace(/\t/g, ' ')
      str = str
        .toString()
        .trim()
        .replace(/(\r\n|\n|\r)/g, '')

      this[field] = ''
      setTimeout(() => {
        this[field] = str
      }, 0)
    }
  }
}
</script>
